import React, { useState } from 'react'
//import { IoMdInformationCircle } from 'react-icons/io'
//import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'
import RegionList from '../components/RegionList'
//import { MediaQueries as Mq } from '../styles/MediaQueries'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { MdOutlineExpandMore } from 'react-icons/md'
import { LOCATION_LABELS } from '../utils/const'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const StyledHeader = styled.p`
  color: var(--baseBlue);
  font-size: 20px;
  font-weight: bold;
  margin-right: 1rem;
`

const RegionInfo = ({ reg }) => {
  const { t } = useTranslation()

  const [expanded, setExpanded] = useState(false)

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <Accordion
      expanded={expanded === 'region'}
      onChange={handleChange('region')}
      //PaperProps={{ sx: { maxHeight: 'unset' } }}
      key={'region'}
      disableGutters
      sx={{
        boxShadow: 'none',
        position: 'unset',
        marginTop: '1rem'
      }}
    >
      <AccordionSummary
        expandIcon={<MdOutlineExpandMore size={28} color={'#386099'} />}
        aria-controls={`region-content`}
        id={`region-header`}
        sx={{
          padding: 0,
          //borderBottom: `1px solid gray`,
          justifyContent: 'flex-start',
          '.MuiAccordionSummary-content': { flexGrow: 'unset' }
        }}
      >
        <StyledHeader>
          {`${t('See the countries in')} ${t(LOCATION_LABELS[reg])}`}
        </StyledHeader>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '2rem 0' }}>
        <RegionList reg={reg} />
      </AccordionDetails>
    </Accordion>
  )
}

export default RegionInfo
